import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import useRequest from "../../hooks/useRequest";
import { useAppContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";

const targetAudience = [
  { name: "All", label: lang("All") },
  { name: "Selected", label: lang("Selected") },
];

const AddNotificationModal = ({
  section,
  show,
  hide,
  data,
  refresh,
  sendingType = "create",
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [selectAudience, setSelectAudience] = useState();
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCity] = useState([]);
  const [searchCity, setSearchCity] = useState("");
  const debouncedSearchCity = useDebounce(searchCity, 300);
  const { country } = useAppContext();
  const [users, setUsers] = useState([]);

  const onCreate = (values) => {
    // return console.log(values,"values")
    const payload = {
      ...values,
      sending_type : data?._id ? "Resend" :  sendingType,
    };

    if (data) payload.resend_id = data?._id;
    console.log(payload, "payload");

    setLoading(true);

    request({
      url: `${apiPath.notification}${data?._id ? `/${data._id}` : ""}`,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const getCustomer = () => {
    request({
      url: apiPath.common.allCustomer,
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (status) {
          setUsers(data ?? []);
        }
        console.log(data, "data");
      },
      onError: (err) => {
        console.log(err);
      },
    });
  };

  useEffect(() => {
    getCustomer();
    if (!!data) {
      form.setFieldsValue({
        ...data,
        users : data?.users?.map((itm)=> itm?.user_id),
        schedule_time: data.schedule_time ? moment(data.schedule_time) : "",
      });
      setSelectAudience(data.audience);

    }
  }, []);

  return (
    <Modal
      width={750}
      open={show}
      maskClosable={false}
      okText={lang("Add")}
      cancelText={lang("Cancel")}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      className="tab_modal"
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <h4 className="modal_title_cls">
          {data ? lang("Update Notification") : lang("Create Notification")}
        </h4>
        <Row gutter={[16, 0]} className="w-100">
          <Col span={24} sm={24} md={12}>
            <Form.Item
              label={lang("Title")}
              name="title"
              rules={[
                {
                  required: true,
                  message: lang("Please Enter Notification Title"),
                },
                {
                  max: 200,
                  message: lang(
                    "Title should not contain more then 200 characters!"
                  ),
                },
                {
                  min: 2,
                  message: lang("Title should contain at least 2 characters!"),
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input
                autoComplete="off"
                placeholder={lang("Enter Notification Title")}
              />
            </Form.Item>
          </Col>
          <Col span={24} sm={24} md={12}>
            <Form.Item
              label={lang("Notification Type")}
              name="notification_type"
              rules={[
                {
                  required: true,
                  message: lang("Please Enter Notification type"),
                },
                {
                  max: 200,
                  message: lang(
                    "Type should not contain more then 200 characters!"
                  ),
                },
                {
                  min: 2,
                  message: lang(
                    "Type should contain at least 2 characters!"
                  ),
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input
                autoComplete="off"
                placeholder={lang("Enter Notification type")}
              />
            </Form.Item>
          </Col>
          <Col span={24} sm={24} md={24}>
            <Form.Item
              label={lang("Notification")}
              name="message"
              rules={[
                {
                  required: true,
                  message: lang("Please Enter Notification Message"),
                },
                {
                  max: 200,
                  message: lang(
                    "Message should not contain more then 200 characters!"
                  ),
                },
                {
                  min: 2,
                  message: lang(
                    "Message should contain at least 2 characters!"
                  ),
                },
              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input
                autoComplete="off"
                placeholder={lang("Enter Notification Message")}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddNotificationModal;
